import React from 'react'

function BusinessGoalTwo() {
    return (
        <div>
            {/* leading business solution area */}
            <div className="rts-business-solution rts-section-gap">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-6">
                            {/* business solution left */}
                            <div className="rts-business-solution-left">
                                <div className="thumbnail">
                                    <img src="assets/images/business-goal/01.png" alt="" />
                                </div>
                                <div className="success-rate">
                                    <h2 className="title">85%</h2>
                                    <span>Success Rate</span>
                                </div>
                            </div>
                            {/* business solution left End */}
                        </div>
                        <div className="col-lg-6">
                            <div className="rts-business-solution-right">
                                <div className="title-area">
                                    <span className="sub">Leading Business SOlution</span>
                                    <h2 className="title">
                                        We Are Help Our <br />
                                        <span>
                                            Clients <span>For Goal</span>
                                        </span>
                                    </h2>
                                </div>
                                <div className="content-area">
                                    <p className="disc">
                                        Nisi aenean mu suscipit ni phasellus gravida primis massa,
                                        rutrum duis semper posuere pharetra magnis porta diam, bibendum
                                        molestie d cursus ante mattis habitasse. Egestas sagittis
                                        curabitur quam business solution
                                    </p>
                                    {/* single business solution */}
                                    <div className="single-business-solution-2">
                                        <div className="icon">
                                            <img src="assets/images/business-goal/icon/01.png" alt="" />
                                        </div>
                                        <div className="content">
                                            <h6 className="title">Strategic Vision Work</h6>
                                            <p className="disc">
                                                Dorem ipsum dolor sit amet, consectetu mod tempor incididunt
                                                business phasellus gravida
                                            </p>
                                        </div>
                                    </div>
                                    {/* single business solution end */}
                                    {/* single business solution */}
                                    <div className="single-business-solution-2">
                                        <div className="icon">
                                            <img src="assets/images/business-goal/icon/02.png" alt="" />
                                        </div>
                                        <div className="content">
                                            <h6 className="title">Tactical Vision Work</h6>
                                            <p className="disc">
                                                Dorem ipsum dolor sit amet, consectetu mod tempor incididunt
                                                business phasellus gravida
                                            </p>
                                        </div>
                                    </div>
                                    {/* single business solution end */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* leading business solution area End */}
        </div>
    )
}

export default BusinessGoalTwo